import { render, staticRenderFns } from "./PaymentDibsEasy.vue?vue&type=template&id=583983e6&"
import script from "./PaymentDibsEasy.vue?vue&type=script&lang=js&"
export * from "./PaymentDibsEasy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports